<template>
  <tr class="row-details">
    <td class="v-align-middle"  colspan="6" v-if="readyToRender">
      <div class="cr_container">
        <customer 
          :customer="customer" 
          :is-details="isDetails"
        ></customer>

        <div class="cr-address">
          <div class="cr-address-head">
            <h4>Adresse(s) concernée(s)</h4>
          </div>

          <validation-address 
            :address="validationRequestable"
          ></validation-address>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
  import { apiV2 } from 'store/api'
  import Customer from "./ValidationRequestable/CustomerV2"
  import ValidationAddress from "./ValidationRequestable/AddressV2"

  export default {
    name:"CustomerRepresentative",

    components:{
      Customer,
      ValidationAddress
    },

    props:["validationRequestId", "isDetails"],

    data() {
      return {
        validationRequest: null
      }
    },

    computed:{
      readyToRender() {
        return this.validationRequest != null
      },

      customer() {
        return this.validationRequest.included.customer
      },

      validationRequestable() {
        return this.validationRequest.included.validation_requestable
      }
    },

    created() {
      const params = {
        with: 'customer,validation_requestable'
      }

      apiV2.getValidationRequest(this.validationRequestId, params)
        .then((response) => this.validationRequest = response.data.data)
    }
  }
</script>

<style scoped>
.cr_container {
  display: flex;
}

.cr_container > div { margin-right: 15px; }
.cr_container > div:last-child { margin-right: 0; }

.cr-representatives {
  border:solid 1px lightgrey;
  padding: 0 15px;
  background-color: white;
  width: 100%;
}

.cr-address {
  border:solid 1px lightgrey;
  padding: 0 15px;
  background-color: white;
  width: 100%;
}

.row-details td {
  background-color: #e0e0e0
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/CustomerRepresentative.vue